module.exports = __webpack_public_path__ + "media/ca_slide27_programa3.b6c2c0fb.mp4";